import React from 'react'
import CommonFilter from '@/components/common/CommonFilter'
import CommonTable, { type TableColumn } from '@/components/common/CommonTable'
import MainHeading from '@/components/common/MainHeading'
import PaginationComponent from '@/components/common/PaginationComponent'
import Layout from '@/components/layout/Layout'
import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
const Company: React.FC = () => {
    const navigate = useNavigate()
    const columns: TableColumn[] = [
        {
            key: "name",
            header: "Name",
        },
        {
            key: "type",
            header: "Type",
        },
        {
            key: "searchedLocation",
            header: "Searched Location",
        },
        {
            key: "address",
            header: "Address",
        },
        {
            key: "location",
            header: "Location",
        },
        {
            key: "range",
            header: "Range",
        },
        {
            key: "status",
            header: "Status",
        },
        {
            key: "isPunchAllowed",
            header: "Is Punch Allowed",
        },
        {
            key: "branchId",
            header: "Branch ID",
        },


    ];

    const data = [
        {
            name: "Main Site",
            type: "office",
            searchedLocation: "Indore, MP",
            address: "123 Business Park",
            // location: {
            //     lat: 22.7196,
            //     lng: 75.8577
            // },
            location: "Indore, MP",
            range: "100",
            status: 'Active',
            isPunchAllowed: '--',
            branchId: "1221"
        }
    ];

    const paginationData = {
        pageSize: 10,
        currentPage: 1,
        total: 100,
        totalPages: 10,
    };
    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title='Company'
                    buttonText='Add Company'
                    buttonIcon={<Plus />}
                    onClick={() => { navigate('/super-admin/create-company') }}
                />
                <CommonFilter />
                <CommonTable columns={columns} data={data} />
                <PaginationComponent
                    paginationData={paginationData}
                    onPageChange={(page) => console.log(page)}
                />
            </div>
        </Layout>
    )
}

export default Company